import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogComponent } from '../components/dialog/dialog.component';
import { CustomerPrivacyInfoComponent } from '../components/customer-privacy-Info/customer-privacy-info.component';

@Injectable({
  providedIn: 'root',
})
export class CustomerPrivacyPopupService {
  constructor(private ngbModal: NgbModal) {}

  confirm(isLarge = true, otherButton: { action: Observable<any>; text: string } = null): Observable<boolean> {
    const modal = this.ngbModal.open(CustomerPrivacyInfoComponent, {
      size: isLarge ? 'lg' : null,
      backdrop: 'static',
    });

    modal.componentInstance.otherButton = otherButton;

    return from(modal.result).pipe(
      catchError((error) => {
        console.warn(error);
        return of(undefined);
      })
    );
  }
}

